export type Held<T> =
  | { for: string; state: "loading" }
  | { for: string; state: "refused"; why: string }
  | { for: string; state: "read"; what: T };

export function opening<T>(conversation: string): Held<T> {
  return { for: conversation, state: "loading" };
}

export function heldFor<T>(held: Held<T>, conversation: string): Held<T> {
  return held.for === conversation ? held : opening(conversation);
}

export function landed<T>(held: Held<T>, answer: Held<T>): Held<T> {
  return answer.for === held.for ? answer : held;
}
